import {
  type CategorizedResponse,
  LocationQueryEnum,
} from "@b2bportal/rbc-activities-api";
import { activitiesApi } from "@overrides/utilities";
import type { ActivityLocationSuggestion } from "../../../components/ActivityLocationAutocomplete/types";

export const fetchActivityLocationAutocomplete = async (
  query: string
): Promise<CategorizedResponse[]> => {
  const res = await activitiesApi.apiV0ActivitiesDestinationAutocompletePost({
    query: { l: query, LocationQuery: LocationQueryEnum.Label },
  });
  // @ts-expect-error - API type definitions may be incomplete
  return res.data.value?.results ?? [];
};

export const fetchPlace = async (
  query: string
): Promise<ActivityLocationSuggestion | undefined> => {
  const locations = await fetchActivityLocationAutocomplete(query);

  // Get the first result from the first category
  const firstCategory = locations?.[0];
  const firstResult = firstCategory?.results?.[0];

  if (firstResult == null || firstCategory == null) {
    return undefined;
  }

  // Build ActivityLocationSuggestion from AutocompleteSuggestion
  return {
    ...firstResult,
    // Convert category to string for ActivityLocationSuggestion
    category: String(firstCategory.category),
    categoryLabel: firstCategory.label,
  } as ActivityLocationSuggestion;
};
